// src/pages/CityForm.js
import React, { useState, useEffect } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import { getCityById, saveCity } from '../services/CityServices';
import './Forms.css';
import { getCountryById } from '../services/CountryServices';

function CityForm() {
  const { id, countryId } = useParams();
  const [city, setCity] = useState({ name: '', code: '', countryId: countryId, latitude: '', longitude: '', stateCode: '' });
  const [country, setCountry ] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCity = async () => {
      try {
        if (id) {
          const cityData = await getCityById(id);
          setCity({
            name: cityData.name || '',
            code: cityData.code || '',
            countryId: cityData.countryId || countryId,
            latitude: cityData.latitude !== undefined ? cityData.latitude : '',
            longitude: cityData.longitude !== undefined ? cityData.longitude : '',
            stateCode: cityData.stateCode || ''
          });
        }
        const countryData = await getCountryById(countryId);
        setCountry(countryData);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };
  
    fetchCity();
  }, [id,countryId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCity({ ...city, [name]: value });
  };

  const handleLatChange = (e) => {
    let val = e.target.value;
    // Permite negativo y hasta 8 decimales
    if (/^-?\d*\.?\d{0,8}$/.test(val) || val === '' || val === '-') {
      setCity({ ...city, latitude: val });
    }
  };

  const handleLngChange = (e) => {
    let val = e.target.value;
    if (/^-?\d*\.?\d{0,8}$/.test(val) || val === '' || val === '-') {
      setCity({ ...city, longitude: val });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await saveCity(city); 
      navigate('/countries/edit/' + countryId);
    } catch (error) {
      setError(error.message);
    }
  };

  if (loading) {
    return <div>Cargando...</div>;
  }

  return (
    <div className="form-container">
      {error && (
      <div>
        <div className='error-message'>
          Hubo un error: {error}
        </div>
        <br/>
      </div>
      )}
      <h2>{id ? 'Editar Ciudad' : 'Nueva Ciudad'}</h2>
      <form onSubmit={handleSubmit} className="city-form">
        <div className="form-group">
          <label htmlFor="city-name">Nombre</label>
          <input
            type="text"
            id="city-name"
            name="name"
            value={city.name}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="city-stateCode">Código de Estado</label>
          <input
            type="text"
            id="city-stateCode"
            name="stateCode"
            value={city.stateCode}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="city-latitude">Latitud</label>
          <input
            type="number"
            id="city-latitude"
            name="latitude"
            step="0.00000001"
            value={city.latitude}
            onChange={handleLatChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="city-longitude">Longitud</label>
          <input
            type="number"
            id="city-longitude"
            name="longitude"
            step="0.00000001"
            value={city.longitude}
            onChange={handleLngChange}
            required
          />
        </div>

        <div className="form-group">
          <button type="submit" className="btn-submit">{id ? 'Guardar Cambios' : 'Agregar Ciudad'}</button>
        </div>
      </form>
      <div className="form-footer">
        <Link to={`/countries/edit/${countryId}`} className="back-link">Regresar a { country.name }</Link>
      </div>
    </div>
  );
}

export default CityForm;
